import { LogoIcon, NavIcons } from "assets/icons";
import { CompanySection, UserRole } from "modules/auth";
import { Route } from "modules/common/common.types";
import { NavItem } from "modules/common/components";
import { Fragment, useMemo } from "react";

import { useCurrentPortalUser } from "../../hooks";
import { CompanyProfileBlock } from "../CompanyProfileBlock";

// Reuse admin Sidebar styles to keep look identical.
import styles from "../../../common/widgets/Sidebar/Sidebar.module.scss";

interface PortalRoute extends Route {
  section: CompanySection;
}

const PORTAL_ROUTES: PortalRoute[] = [
  {
    label: "Dashboard",
    icon: <NavIcons.DashboardIcon />,
    path: "/company",
    section: CompanySection.Dashboard
  },
  {
    label: "Orders",
    icon: <NavIcons.OrdersIcon />,
    path: "/company/orders",
    section: CompanySection.Orders
  },
  {
    label: "Drivers",
    icon: <NavIcons.IndividualDriverIcon />,
    path: "/company/drivers",
    section: CompanySection.Drivers
  },
  {
    label: "Financial",
    icon: <NavIcons.FinancialIcon />,
    path: "/company/financial",
    section: CompanySection.Financial
  },
  {
    label: "Staff Management",
    icon: <NavIcons.StaffIcon />,
    path: "/company/staff",
    section: CompanySection.StaffManagement
  },
  {
    label: "Company Settings",
    icon: <NavIcons.SettingsIcon />,
    path: "/company/settings",
    section: CompanySection.CompanySettings
  }
];

const CompanyAdminSidebar = () => {
  const { role, allowedSections } = useCurrentPortalUser();
  const isManager = role === UserRole.CompanyManager;

  const visibleRoutes = useMemo(
    () =>
      PORTAL_ROUTES.filter((r) => {
        if (isManager && r.section === CompanySection.CompanySettings)
          return false;
        if (isManager) return allowedSections.includes(r.section);
        return true;
      }),
    [isManager, allowedSections]
  );

  return (
    <div className={styles.sidebar}>
      <div className={styles.sidebar__logo}>
        <LogoIcon width={173} height={41} />
      </div>

      <nav className={styles.sidebar__nav}>
        {visibleRoutes.map((route) => (
          <Fragment key={route.label}>
            <NavItem route={route} />
          </Fragment>
        ))}
      </nav>

      <div className={styles.sidebar__profile}>
        <CompanyProfileBlock />
      </div>
    </div>
  );
};

export default CompanyAdminSidebar;
